import { Box } from '@mui/material';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import ClassRoom from './pages/classroom/classroom';
import Overview from './pages/classroom/overview/overview';
import Assessments from './pages/classroom/assessment/admin/preview';
import AssessmentDetail from './pages/classroom/assessment/admin/details';
import AssessmentPreview from './pages/classroom/assessment/public/assessment-preview';
import CollectionDetails from './pages/classroom/library/admin/details';
import AssessmentsCollab from './pages/classroom/assessment/collab/assessments';
import CollectionsCollab from './pages/classroom/lecture/collab/collections';
import AssessmentDetailCollab from './pages/classroom/assessment/collab/assessment-detail';
import AssessmentPreviewCollab from './pages/classroom/assessment/collab/assessment-preview';
import CollectionDetailsCollab from './pages/classroom/lecture/collab/collection-details';
import NoteEditor from './pages/classroom/library/note-editor';
import CollabDashboard from './pages/collab/dashboard';
import ClassRoomCollab from './pages/collab/classroom';
import Students from './pages/students/students';
import Account from './pages/account/account';
import Payout from './pages/payout/payout';
import SignIn from './pages/auth/sign-in';
import SignUp from './pages/auth/sign-up';
import Verify from './pages/auth/verify';
import ResetPassword from './pages/auth/reset-password';
import LectureDetails from './pages/classroom/lecture/admin/details';
import { AuthProvider } from './auth/AuthProvider';
import ProtectedRoute from './auth/ProtectedRoute';
import TermsOfUse from './pages/terms-of-use';
import PrivacyPolicy from './pages/privacy-policy';
import SubmissionDetails from './pages/classroom/assessment/admin/SubmissionDetails';



function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={
            <ProtectedRoute>
              <Dashboard/>
            </ProtectedRoute>
          }/>
          <Route path='/sign-in' element={<SignIn/>}/>
          <Route path='/sign-up' element={<SignUp/>}/>
          <Route path='/verify/:action' element={<Verify/>}/>
          <Route path='/reset-password' element={<ResetPassword/>}/>
          <Route path='/terms-of-use' element={<TermsOfUse/>}/>
          <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
          <Route path='/payout' element={
            <ProtectedRoute>
              <Payout/>
            </ProtectedRoute>
          }/>
          <Route path='/students' element={
            <ProtectedRoute>
              <Students/>
            </ProtectedRoute>
          }/>
          <Route path='/account' element={
            <ProtectedRoute>
              <Account/>
            </ProtectedRoute>
          }/>
          <Route path="/classroom/:classroom_id" element={
            <ProtectedRoute>
              <ClassRoom />
            </ProtectedRoute>
          }/>

          <Route
            path="/classroom/:classroom_id/lectures/:lecture_id"
            element={
              <ProtectedRoute>
                <LectureDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/classroom/:classroom_id/assessments/:assessment_id"
            element={
              <ProtectedRoute>
                <AssessmentDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/classroom/:classroom_id/assessments/:assessment_id/preview"
            element={
              <ProtectedRoute>
                <AssessmentPreview />
              </ProtectedRoute>
            }
          />

          <Route
            path="/classroom/:classroom_id/assessments/:assessment_id/submissions/:submission_id"
            element={
              <ProtectedRoute>
                <SubmissionDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/classroom/:classroom_id/library/collections/:collection_id"
            element={
              <ProtectedRoute>
                <CollectionDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/classroom/:classroom_id/library/collections/:collection_id/notes/:resource_title"
            element={
              <ProtectedRoute>
                <NoteEditor />
              </ProtectedRoute>
            }
          />

          {/* <Route
            path="/collab/:access_code"
            element={<CollabDashboard/>}
          /> */}
          {/* <Route path="/collab/:access_code/classroom/:classroom_id" element={<ClassRoomCollab />}>
            <Route path="lectures" element={<Lectures />} />
            <Route path="assessments" element={<AssessmentsCollab />} />
            <Route path="library" element={<CollectionsCollab />} />
          </Route> */}


          {/* <Route
            path="/collab/:access_code/classroom/:classroom_id/assessments/:assessment_id"
            element={<AssessmentDetailCollab />}
          />
          <Route
            path="/collab/:access_code/classroom/:classroom_id/assessments/:assessment_id/preview"
            element={<AssessmentPreviewCollab />}
          />
          <Route
            path="/collab/:access_code/classroom/:classroom_id/library/collections/:collection_id"
            element={<CollectionDetailsCollab />}
          />
          <Route
            path="/collab/:access_code/classroom/:classroom_id/library/collections/:collection_id/notes/:resource_title"
            element={<NoteEditor />}
          /> */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
